import React from "react";
import { useNavigate } from "react-router-dom";
import { AppLayout } from "layouts";
import SurveyForm from "components/SurveyForm";

import { useDispatch, useSelector } from "store";
import { submitSurvey } from "services/survey";

import { SurveyRequest } from "typings/app/types";
// import { LdNotice } from "@emdgroup-liquid/liquid/dist/react";

const NewSurvey = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, error } = useSelector(({ survey }) => survey);
  const handleSubmit = async (survey: SurveyRequest) => {
    const response = await dispatch(submitSurvey(survey));
    navigate(`/surveys/${response.payload.surveyId}`);
  };
  return (
    <AppLayout>
      <div className="container flex mx-auto flex-col items-center pt-ld-32 px-ld-16 md:px-ld-32">
        {/* {status === "failed" && error !== undefined && (
          <LdNotice headline="An error occurred" mode="error">
            {error}
          </LdNotice>
        )} */}
        <SurveyForm isLoading={status === "loading"} onSubmit={handleSubmit} />
      </div>
    </AppLayout>
  );
};

export default NewSurvey;
